// @ts-nocheck
/**
 * Cart line quantity dropdown: same interaction pattern as product-pagination dropdown.
 * Dispatches quantity-selector:update and keeps hidden updates[] + duplicate mobile/desktop UIs in sync.
 */

const OPEN_CONTAINER_CLASS = 'cart-page__item-quantity-dropdown--open';

function getLineIndex(container) {
  return parseInt(container.dataset.lineIndex, 10);
}

function syncAllUisForLine(lineIndex, quantity) {
  const qtyStr = String(quantity);
  document.querySelectorAll(`.cart-page__item-quantity-dropdown[data-line-index="${lineIndex}"]`).forEach((peer) => {
    const btnText = peer.querySelector('.product-pagination__dropdown-button-text');
    if (btnText) btnText.textContent = qtyStr;
    peer.querySelectorAll('.product-pagination__dropdown-option').forEach((opt) => {
      const optVal = parseInt(opt.dataset.value, 10);
      const isSel = optVal === quantity;
      opt.classList.toggle('product-pagination__dropdown-option--selected', isSel);
      opt.setAttribute('aria-selected', isSel ? 'true' : 'false');
    });
  });
  const hidden = document.querySelector(`.cart-page__item-quantity-hidden[data-line-index="${lineIndex}"]`);
  if (hidden) hidden.value = qtyStr;
}

function closeDropdown(container) {
  if (!container.classList.contains(OPEN_CONTAINER_CLASS)) return;
  const button = container.querySelector('.product-pagination__dropdown-button');
  const dropdown = container.querySelector('.product-pagination__dropdown-list');
  const arrow = container.querySelector('.product-pagination__dropdown-arrow');
  const options = container.querySelectorAll('.product-pagination__dropdown-option');

  container.classList.remove(OPEN_CONTAINER_CLASS);
  dropdown?.classList.remove('product-pagination__dropdown-list--open');
  button?.classList.remove('product-pagination__dropdown-button--open');
  button?.setAttribute('aria-expanded', 'false');
  options.forEach((option) => {
    option.setAttribute('tabindex', '-1');
  });
  if (arrow) arrow.style.transform = 'rotate(0deg)';
}

function openDropdown(container) {
  const button = container.querySelector('.product-pagination__dropdown-button');
  if (button?.disabled) return;

  const dropdown = container.querySelector('.product-pagination__dropdown-list');
  const arrow = container.querySelector('.product-pagination__dropdown-arrow');
  const options = container.querySelectorAll('.product-pagination__dropdown-option');

  container.classList.add(OPEN_CONTAINER_CLASS);
  dropdown?.classList.add('product-pagination__dropdown-list--open');
  button?.classList.add('product-pagination__dropdown-button--open');
  button?.setAttribute('aria-expanded', 'true');
  options.forEach((option) => {
    option.setAttribute('tabindex', '0');
  });
  if (arrow) arrow.style.transform = 'rotate(180deg)';
}

function closeAllCartQuantityDropdowns() {
  document.querySelectorAll(`.${OPEN_CONTAINER_CLASS}`).forEach((c) => closeDropdown(c));
}

function toggleDropdown(container) {
  if (container.classList.contains(OPEN_CONTAINER_CLASS)) {
    closeDropdown(container);
  } else {
    closeAllCartQuantityDropdowns();
    openDropdown(container);
  }
}

function getCartItemsComponent() {
  return document.querySelector('body.template-cart cart-items-component, cart-items-component.tjc_cart_pg, cart-items-component');
}

function invokeCartQuantityUpdate(lineIndex, quantity) {
  const cartItems = getCartItemsComponent();

  if (cartItems && typeof cartItems.updateQuantity === 'function') {
    cartItems.updateQuantity({ line: lineIndex, quantity, action: 'change' });
    return;
  }

  document.dispatchEvent(
    new CustomEvent('quantity-selector:update', {
      bubbles: true,
      detail: {
        quantity,
        cartLine: lineIndex,
      },
    })
  );

  if (typeof window.updateCartItem === 'function') {
    window.updateCartItem(lineIndex, quantity);
  }
}

function handleOptionSelect(container, option) {
  const button = container.querySelector('.product-pagination__dropdown-button');
  if (button?.disabled) return;

  const value = option.dataset.value;
  if (value == null || value === '') return;
  const quantity = parseInt(value, 10);
  if (Number.isNaN(quantity) || quantity < 1) return;

  const lineIndex = getLineIndex(container);
  syncAllUisForLine(lineIndex, quantity);
  closeDropdown(container);

  invokeCartQuantityUpdate(lineIndex, quantity);
}

let delegationBound = false;

function bindDelegation() {
  if (delegationBound) return;
  delegationBound = true;

  document.body.addEventListener('click', (e) => {
    const quantityWrap = e.target.closest('.cart-page__item-quantity');
    const container =
      e.target.closest('.cart-page__item-quantity-dropdown') ||
      quantityWrap?.querySelector('.cart-page__item-quantity-dropdown');

    if (container) {
      const option = e.target.closest('.product-pagination__dropdown-option');

      if (option && container.contains(option)) {
        e.stopPropagation();
        handleOptionSelect(container, option);
        return;
      }

      if (quantityWrap?.contains(e.target) || e.target.closest('.product-pagination__dropdown-button')) {
        e.stopPropagation();
        toggleDropdown(container);
        return;
      }

      return;
    }
    closeAllCartQuantityDropdowns();
  });

  document.body.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllCartQuantityDropdowns();
      return;
    }
    const option = e.target.closest('.cart-page__item-quantity-dropdown .product-pagination__dropdown-option');
    if (option && (e.key === 'Enter' || e.key === ' ')) {
      const container = option.closest('.cart-page__item-quantity-dropdown');
      if (container) {
        e.preventDefault();
        handleOptionSelect(container, option);
      }
    }
  });
}

window.syncCartPageQuantityUi = syncAllUisForLine;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindDelegation);
} else {
  bindDelegation();
}
